import { gql, useMutation } from '@apollo/client';
import { Mutation, MutationRemoveVoucherArgs } from '../types/types';

export const removeVoucherMutation = gql`
  mutation RemoveVoucher($offerId: String!) {
    removeVoucher(offerId: $offerId)
  }
`;

export function useRemoveVoucher() {
  return useMutation<Pick<Mutation, 'removeVoucher'>, MutationRemoveVoucherArgs>(removeVoucherMutation);
}